export default __webpack_public_path__ + "static/logo-horizontal-92527b44ea6ddbe0908dbae4e42ca5ba.svg";